<!-- A mail filed earlier only gets a quiet note: the targets are what matters,
     while right after filing the confirmation is the news. -->
<div
  class="flex flex-col items-center gap-4 text-center"
  [class]="alreadyFiled() ? 'pt-4' : 'py-10'">
  @if (alreadyFiled()) {
    <p class="flex items-center gap-1.5 self-start text-sm font-medium text-main">
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.5"
          d="M5 13l4 4L19 7" />
      </svg>
      {{ 'uploadSuccess.alreadyFiled' | translate }}
    </p>
  } @else {
    <cmi-filed-heading [title]="'uploadSuccess.title' | translate" />
  }

  <cmi-filed-targets [targets]="filings()" />

  @if (limitReached()) {
    <cmi-notification
      class="block w-full text-left"
      mode="info"
      [message]="'uploadSuccess.limitReached' | translate: maxFilings" />
  } @else {
    <cmi-button
      [label]="
        (alreadyFiled() ? 'uploadSuccess.fileAgain' : 'uploadSuccess.fileAnother') | translate
      "
      (clicked)="onFileAnother()" />
  }
</div>
